import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, Clock, MapPin, Lock } from "lucide-react";
import { CONTACT, INSTAGRAM, NAV } from "@/lib/site";
import { Logo } from "./Navbar";

export const Footer = () => (
  <footer className="bg-black border-t border-white/10" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20 grid gap-12 md:grid-cols-12">
      <div className="md:col-span-5">
        <Logo />
        <p className="mt-8 font-display text-3xl gold-text italic">Strategy Over Everything.</p>
        <p className="mt-4 text-white/60 max-w-sm text-sm leading-relaxed">
          Simply Good People Providing Exceptional Service. Empowering individuals through financial education,
          strategic tax preparation, business development and financial solutions.
        </p>
        <a href={INSTAGRAM.url} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link"
          className="mt-6 inline-flex items-center gap-3 py-2 text-sm text-white/80 hover:text-[#D4AF37] transition-colors">
          <Instagram className="w-5 h-5" /> {INSTAGRAM.handle}
        </a>
      </div>
      <div className="md:col-span-3">
        <p className="eyebrow mb-6">Explore</p>
        <ul className="grid grid-cols-2 md:grid-cols-1 gap-x-6 md:space-y-1">
          {[...NAV, { to: "/get-started", label: "Get Started" }, { to: "/login", label: "Client Portal" }].map((n) => (
            <li key={n.to}><Link to={n.to} className="inline-block py-2 text-sm text-white/65 hover:text-white transition-colors" data-testid={`footer-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}>{n.label}</Link></li>
          ))}
        </ul>
      </div>
      <div className="md:col-span-4">
        <p className="eyebrow mb-6">Contact</p>
        <ul className="space-y-2 text-sm text-white/65" data-testid="footer-contact">
          <li><a href={CONTACT.emailHref} className="flex gap-3 py-2 hover:text-[#D4AF37] transition-colors" data-testid="footer-email-link"><Mail className="w-4 h-4 text-[#D4AF37] mt-0.5" />{CONTACT.email}</a></li>
          <li><a href={CONTACT.phoneHref} className="flex gap-3 py-2 hover:text-[#D4AF37] transition-colors" data-testid="footer-phone-link"><Phone className="w-4 h-4 text-[#D4AF37] mt-0.5" />{CONTACT.phone}</a></li>
          <li className="flex gap-3"><Clock className="w-4 h-4 text-[#D4AF37] mt-0.5" />{CONTACT.hours}</li>
          <li className="flex gap-3"><MapPin className="w-4 h-4 text-[#D4AF37] mt-0.5" />{CONTACT.location}</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row gap-3 justify-between text-xs text-white/45">
        <span>© 2026 Baggs 2 Riches LLC. All rights reserved.</span>
        <span className="flex items-center gap-2"><Lock className="w-3.5 h-3.5" /> Your information is transmitted over a secure connection.</span>
      </div>
    </div>
  </footer>
);
